import { createScopedRowsClient } from "#ce/shared/filters/api/scoped-rows-client";

/**
 * Returns the section a filter's options are served under: the form field name without its
 * array suffix (`"age_group"` for `"age_group"`, `"categories"` for `"categories[]"`).
 *
 * @param {String} name
 * @returns {String}
 */
export function sectionFor(name) {
  return String(name ?? "").replace(/\[\]$/, "");
}

/**
 * Returns the rows of a section. A section is an array of rows, or named groups of rows
 * (`language` is `{ common: [...], all: [...] }`), which are concatenated. A bare array is read as
 * the rows themselves, and an absent section has none.
 *
 * @param {unknown} payload
 * @param {String} section
 * @returns {Array<Object>}
 */
export function rowsOf(payload, section) {
  const value = Array.isArray(payload) ? payload : payload?.[section];

  if (Array.isArray(value)) {
    return value;
  }
  if (value && typeof value === "object") {
    return Object.values(value).flatMap((group) => (Array.isArray(group) ? group : []));
  }

  return [];
}

/**
 * Returns the data source for a list filter's scoped options. Unparsed: the filter reads `slug`,
 * `value` or `id` off plain objects.
 *
 * @param {Object} options
 * @param {String} options.url - The endpoint, requested as given with the scope appended.
 * @param {String} options.section - The section the rows are read from, see {@link sectionFor}.
 * @throws {TypeError} Without a `url`.
 */
export const createCategoryFilterApi = ({ section, url } = {}) =>
  createScopedRowsClient({
    url,
    section,
    readRows: (payload) => rowsOf(payload, section),
  });
